var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelpSysreq = function SvgHelpSysreq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 100 18A9 9 0 009 0zm0 13.752l-.088.018h-.18c-.054-.01-.108-.02-.16-.035a.997.997 0 11.433.016L9 13.752zm2.88-6.535a2.225 2.225 0 01-.522.883 5.96 5.96 0 01-.9.74c-.18.12-.34.254-.51.383a1.08 1.08 0 00-.332.48 4.979 4.979 0 01-.12.292.67.67 0 01-.627.444.876.876 0 01-.455-.072.744.744 0 01-.409-.557 1.278 1.278 0 01.216-.96 2.62 2.62 0 01.565-.6c.24-.192.48-.376.72-.569.2-.153.368-.345.494-.564.2-.378.153-.84-.12-1.17a.972.972 0 00-.54-.299 1.718 1.718 0 00-.84.015 1.021 1.021 0 00-.65.54c-.086.158-.16.32-.24.48a1.168 1.168 0 01-.234.326.805.805 0 01-.61.196.84.84 0 01-.384-.105.666.666 0 01-.36-.6c-.01-.397.117-.786.36-1.101.28-.379.651-.68 1.08-.875a3.294 3.294 0 011.023-.295l.202-.02h.36l.194.019c.482.03.953.152 1.389.36.39.178.722.461.96.818.184.287.296.614.326.954.048.285.036.577-.036.857z",
    fill: "#0082ED",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpSysreq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-sysreq.5680b8ff.svg";
export { ForwardRef as ReactComponent };